<template lang='pug'>
a.media-itemGallery(:href="info.url" target="_blank")
  .media-leftGallery
    .media-imageGallery(v-if="info.thumbnailUrl" :style='"background-image: url(" + info.thumbnailUrl + ");"')
    .media-imageGallery(v-else :style="defaultImage")
  .media-rightGallery
    .media-topRightGallery
      v-clamp.media-titleGallery(autoresize :max-lines="1") {{ info.title }}
      v-clamp.media-subtitleGallery(autoresize :max-lines="1") {{ info.subTitle }}
    .media-bottomRightGallery
      v-clamp.media-descriptionGallery.show--bigScreens(autoresize :max-lines="3") {{ info.content }}
</template>
<script>
import VClamp from 'vue-clamp'
export default {
  components: {
    VClamp
  },
  props: {
    info: Object
  },
  computed: {
    defaultImage() {
      return "background-image: url('" + process.env.VUE_APP_CDN_URL + "/category/fig-default-2.png');";
    }
  }
}
</script>
